import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useEffect, useState } from "react";
import { getUserList } from '../../../api';
import useUserParams from './useUserParams';
export var useUsers = function useUsers() {
  var _useState = useState({
    rows: [],
    total: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      userTableData = _useState2[0],
      setUserTableData = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      userListLoading = _useState4[0],
      setUserListLoading = _useState4[1];

  var _useUserParams = useUserParams(),
      _useUserParams2 = _slicedToArray(_useUserParams, 2),
      userParams = _useUserParams2[0],
      updateUserParams = _useUserParams2[1];

  var fetchUsers = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$getUserList, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getUserList(userParams);

          case 3:
            _yield$getUserList = _context.sent;
            data = _yield$getUserList.data;
            setUserTableData(data);
            setUserListLoading(false);
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            setUserTableData({
              rows: [],
              total: 0
            });
            setUserListLoading(false);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  })), [userParams]);
  useEffect(function () {
    setUserListLoading(true);
    fetchUsers();
  }, [fetchUsers, userParams]);

  var updateUsers = function updateUsers() {
    setUserListLoading(true);
    fetchUsers();
  };

  return [userTableData.rows, userTableData.total, userListLoading, userParams, updateUserParams, updateUsers];
};
export default useUsers;